<template>
  <div class="loginbg">
    <div class="contentfrom">
      <img :src="headLogo" width="130"/>
      <H1 class="loginTitle">{{ assessName}}</H1>
      <el-card class="box-card">
        <el-form ref="login" :model="form" label-width="0" :rules="ruleLogin">
          <el-form-item style="margin-top:40px;" prop="loginPhone">
            <el-input placeholder="请输入手机号码" v-model.trim="form.loginPhone">
              <img src="../images/account.png" slot="prepend" width="20"/>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-top:40px;" prop="verifyCode">
            <el-input
              placeholder="请输入验证码"
              v-model.trim="form.verifyCode"
              type="text"
              maxlength="6"
            >
              <img src="../images/password.png" slot="prepend" width="20"/>
              <el-button
                slot="append"
                round
                class="appendbtn"
                size="mini"
                @click="getcode"
                :disabled="!canClick"
              >{{ getCodeTitle }}
              </el-button
              >
            </el-input>
          </el-form-item>
        </el-form>
        <el-button
          @click="login"
          type="primary"
          style="width: 100%; margin: 20px 0"
          round
          class="mt20"
        >登录
        </el-button
        >
      </el-card>
    </div>
  </div>
</template>
<script>
import HttpRequest from "@/utils/request";
import {setSessionData} from "../utils/cache";
import md5 from 'js-md5'
import {parseQuestNameByCode} from "@/assets/js/questIntro";

export default {
  name: "leftMenu",
  data() {
    var validatePhone = (rule, value, callback) => {
      var myreg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!myreg.test(value)) {
        callback(new Error("手机号码格式不正确"));
      } else {
        callback();
      }
    };
    return {
      ruleLogin: {
        verifyCode: [
          {required: true, message: "请输入验证码", trigger: "blur"}
        ],
        loginPhone: [
          {required: true, message: "请输入手机号", trigger: "blur"},
          {validator: validatePhone, trigger: "blur"}
        ]
      },
      form: {
        partner: null,
        loginPhone: "",
        verifyCode: ""
      },
      canClick: true,
      totalTime: 60,
      getCodeTitle: "获取验证码",
      headLogo: '',
      assessName: '',
      //定义加密是否一致
      flag: false,
      encryptedQuestCode: '',
      urlParams: '',
      urlObj: '',
    };
  },
  created() {
    //logo
    let partner = this.$route.query.partner
    let command = this.$route.query.command
    if (!partner || partner === 'undefined') {
      this.$alert('登录网址不对');
    } else {
      this.form.partner = partner
      this.headLogo = 'https://sys.rennengda.com/consult/logos/head-' + partner + '.png';
      this.openOtherHomepage = this.$route.query.openOtherHomepage
      this.assessName = parseQuestNameByCode(command)
    }
    //加密
    let urlObjArr = window.location.search.split('?')
    const urlObj = urlObjArr[1];
    console.log(urlObj);
    let urlObjMap = Object.fromEntries(new URLSearchParams(urlObj));
    this.urlObj = urlObjMap
    //进行排序
    const keySort = Array.from(Object.keys(urlObjMap)).sort();
    // 生成排序后的参数字符串
    keySort.forEach((key) => {
      if (key !== 'sign') { //排除sign参数
        const value = urlObjMap[key];
        this.urlParams += `${key}=${value}&`;
      }
    })
    const secreKey = 'shengya100';
    let sign = md5(this.urlParams + secreKey)
    sign = sign.substring(sign.length - 16);
    console.log(sign)
    //判断加密是否一致
    this.flag = sign === this.urlObj.sign
    if (!this.flag || !(urlObj.includes("partner") && urlObj.includes("command") && urlObj.includes("sign"))) {
      // 跳转 非法参数
      this.$router.push('/error')
    }
    this.form.partner = urlObjMap['partner']
    if (!this.form.partner || this.form.partner == "undefined") {
      this.$alert("登录网址不对");
    }
  },
  mounted() {
  },
  methods: {
    login() {
      this.$refs["login"].validate(valid => {
        if (valid) {
          let url = "/constub/loginBySms";
          let data = {
            partner: this.form.partner,
            loginPhone: this.form.loginPhone,
            verifyCode: this.form.verifyCode
          };

          HttpRequest.requestFormPost(url, data).then(res => {
            if (res && res.result.success) {
              store.dispatch('setStudent', res.data)
              store.dispatch('setLoginStatus', 1)
              if (res.data.studentName) {
                this.$router.push({
                  name: 'simpleQuestIntro',
                  params: {'questCode': this.urlObj.command}
                })
              } else {
                this.$alert("首次登录，请先填写个人资料", {
                  showClose: false,
                  confirmButtonText: "继续",
                  callback: action => {
                    this.$router.push("/firstPersonalData?pathfrom=" + this.urlObj.command);
                  }
                });
              }
            } else {
              this.$alert(res.result.message, {
                confirmButtonText: "确定",
                showClose: false
              });
            }
          });
        }
      });
    },
    getcode() {
      if (!this.form.partner) {
        this.$message.error("登录网址不对");
        return;
      }
      let phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!phoneReg.test(this.form.loginPhone)) {
        this.$message({message: "手机号码不正确", type: "warning"});
        return;
      }
      if (this.canClick) {
        this.canClick = false;
        //倒计时
        this.getCodeTitle = this.totalTime + "s后重新发送";
        let clock = window.setInterval(() => {
          this.totalTime--;
          this.getCodeTitle = this.totalTime + "s后重新发送";
          if (this.totalTime < 0) {
            window.clearInterval(clock);
            this.getCodeTitle = "重新发送验证码";
            this.totalTime = 60;
            this.canClick = true;
          }
        }, 1000);
        //发送验证码
        let url = "/constub/sendVerifyCode";
        let data = {
          partner: this.form.partner,
          toPhoneNum: this.form.loginPhone
        };
        HttpRequest.requestFormPost(url, data).then(res => {
          if (res && res.result.success) {
            this.$message({message: res.data, type: "success"});
          } else {
            this.$alert(res.result.message, {
              confirmButtonText: "确定",
              showClose: false
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.loginbg {
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: url("../images/bg.png");
  background-size: cover;
}

.contentfrom {
  position: absolute;
  width: 80%;
  left: 50%;
  top: 50px;
  transform: translateX(-50%);
  text-align: center;
}

.contentfrom input {
  border: 0;
}

>>> .el-input-group__append,
>>> .el-input-group__prepend {
  border: 0;
  border-radius: 0;
  background: none;
  border-bottom: 1px solid #8d93b9;
}

>>> .el-input__inner {
  color: #8d93b9;
  background: none;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #8d93b9;
}

.appendbtn {
  border: 1px solid #8d93b9 !important;
}

.loginTitle {
  margin: 20px 0 40px;
  color: #fff;
}

.foot {
  position: absolute;
  width: 80%;
  left: 50%;
  bottom: 50px;
  transform: translateX(-50%);
  text-align: center;
  color: #fff;
}
</style>
